import { render, staticRenderFns } from "./DependentWorkingVisa.vue?vue&type=template&id=418701c6&"
import script from "./DependentWorkingVisa.vue?vue&type=script&lang=js&"
export * from "./DependentWorkingVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports